import services from '../../../services'

const state = {
}

const actions = {
  async pageFindVewList ({ commit }, query) {
    return await services.view_pageFind(query)
  },
  async saveView({ commit }, data) {
    return await services.view_save(data)
  },
  async checkUpload({ commit }, data) {
    return await services.view_checkUpload(data)
  },
  async view_isBindRegion({ commit }, data) {
    return await services.isBindRegion(data)
  },
  async remove_view({ commit }, data) {
    return await services.remove(data)
  },
  async edit_view({ commit }, data) {
    return await services.view_edit(data)
  },
  async check_view_name({ commit }, data) {
    return await services.check_view_name(data)
  },
  async viewBindPlace({ commit }, data) {
    return await services.bindRegion(data)
  },
  async unbind_view({ commit }, data) {
    return await services.unBind(data)
  },
  async update_view_region({ commit }, data) {
    return await services.updateRegion(data)
  },
  async update_Status({ commit }, data) {
    return await services.updateStatus(data)
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/view.js